import ErrorCard from './errorCard.js';
export default ErrorCard;
